import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { Update } from '../sections/@dashboard/manageProperty';
import { Unauthorized } from '../sections/@dashboard/manageUser';
import { usePropertyViewQuery } from '../services/dvagent';
import { Toaster } from '../sections/@dashboard/attributes';
import { getToken } from '../services/LocalStorageService';
import { PropertyViewCard } from '../components/skeleton';

export default function PropertyUpdate() {

  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [property, setProperty] = useState({});
  const { data, isSuccess, error } = usePropertyViewQuery({ "id": location.state, "token": getToken(), "location":location });

  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  useEffect(() => {
    if (error) {
      if (error.status === 401) {
        showToast(false, 'ⓘ', 'Access Denied');
      } else if(error.status === 'PARSING_ERROR') {
        showToast(false, 'ⓘ', 'PARSING ERROR');
        navigate('/cloud/properties')
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
      setLoading(true);
    }
    if (data && isSuccess) {
      setProperty(data.property);
      setLoading(true);
    }
  }, [data, isSuccess, error]);  

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Container maxWidth="xxl">
        {loading ? (
          error?.status === 401 || error?.status === 'PARSING_ERROR' ? (
            <Grid container spacing={2} mt={10}>
              <Unauthorized />
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Update property={property} />
            </Grid>
          )
        ) : (
          <Grid container spacing={2}>
            <PropertyViewCard />
          </Grid>
        )}
      </Container>
    </>
  );
}